export const ENVIRONMENT_PROD = 'PROD';
export const ENVIRONMENT_STAGE = 'STAGE';
export const ENVIRONMENT_DEV = 'DEV';
export const ENVIRONMENT_LOCAL = 'LOCAL';

export const ENVIRONMENTS = [ENVIRONMENT_PROD, ENVIRONMENT_STAGE, ENVIRONMENT_LOCAL];

export const DATA_API_PRODUCTION = 'https://app.koeln-marathon.de/api/v1';
export const DATA_API_STAGE = 'https://laeufertracking.koelnmstag.fcio.net/api/v1';
export const DATA_API_DEV = 'https://app.koeln-marathon.pooliestudios.cloud/api/v1';
export const DATA_API_LOCAL = 'http://koeln-marathon.localhost:8080/api/v1';

export const API_ENDPOINTS = {
    [ENVIRONMENT_PROD]: {
        DATA: DATA_API_PRODUCTION,
    },
    [ENVIRONMENT_STAGE]: {
        DATA: DATA_API_STAGE,
        Authorization: 'Basic cG9vbGllc3R1ZGlvczpwb29saWU=',
    },
    [ENVIRONMENT_DEV]: {
        DATA: DATA_API_DEV,
        Authorization: 'Basic cG9vbGllY2xvdWQ6Y2xvdWQ=',
    },
    [ENVIRONMENT_LOCAL]: {
        DATA: DATA_API_LOCAL,
    },
};

// Environment Bezeichnungen von Symfony
export const PUSH_PROD = 'prod';
export const PUSH_STAGE = 'stage';
export const PUSH_LOCAL = 'dev';

export const PUSH_ENVIRONMENTS = {
    [ENVIRONMENT_PROD]: PUSH_PROD,
    [ENVIRONMENT_STAGE]: PUSH_STAGE,
    [ENVIRONMENT_LOCAL]: PUSH_LOCAL,
};
